<template>
  <div id="map"></div>
</template>

<script>
import GoogleMapsLoader from 'google-maps'

export default {
  name: 'GoogleMap',
  data () {
    return {
    }
  },
  mounted: function () {
    GoogleMapsLoader.KEY = 'AIzaSyBJKiBkMF_Zuk-c4sT1WbmzOLckSnK-Hac'
    GoogleMapsLoader.load(function (google) {
      let map = new google.maps.Map(document.getElementById('map'), {
        zoom: 8,
        center: new google.maps.LatLng(-43.998424, -176.407621),
        zoomControl: true,
        mapTypeControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false
      })
      console.log(map)
    })
  }
}
</script>

<style scoped>
#map {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/GoogleMap.vue